<div class="export-notification" *ngIf="progress >= 1 || exportQueue.length" [@fadeInOut]="notificationState">
  <div class="progress-container">
    <!-- Spinner -->
    <mat-progress-spinner *ngIf="progress < 100 && !exportError" mode="determinate" [value]="progress" diameter="40"
      strokeWidth="4" class="custom-spinner">
    </mat-progress-spinner>
    <div class="percentage-text" *ngIf="progress < 100 && !exportError">{{ progress }}%</div>

    <!-- Check Icon -->
    <div class="check-container" *ngIf="progress === 100 && !exportError">
      <mat-icon class="check-icon">check</mat-icon>
    </div>

    <!-- Error Icon -->
    <div class="error-container" *ngIf="exportError">
      <mat-icon class="error-icon">error</mat-icon>
    </div>
  </div>

  <div class="export-text">
    <strong *ngIf="progress < 100 && !exportError">Exporting</strong>
    <strong *ngIf="progress === 100">Exported!</strong>
    <strong *ngIf="exportError" class="export-error-text">Error Occurred</strong>
    <p *ngIf="progress < 100 && !exportError">Please Wait...</p>
  </div>

  <!-- Dropdown Icon -->
  <mat-icon class="arrow-icon" (click)="toggleQueueDropdown()" *ngIf="exportQueue.length">
    {{ showQueueDropdown ? 'expand_less' : 'expand_more' }}
  </mat-icon>

  <!-- Dropdown for pending items -->
  <div class="dropdown-panel" [class.show]="showQueueDropdown && exportQueue.length" (click)="$event.stopPropagation()">
    <div class="dropdown_item ng-option-label" *ngFor="let item of exportQueue">
      <span>{{ item.name | titlecase }}</span>
      <span>{{ '0' }}%</span>
    </div>
  </div>
</div>
